import type { CtaBlockFragment } from '@/lib/types/datocms/graphql/generated'
import Image from 'next/image'
import { StructuredText } from 'react-datocms'
import CtaDefault from '../ui/cta/CtaDefault'
import { TextWithHighlight } from '../TextWithHighlight'
import clsx from 'clsx'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'

export default function CtaBlockSection({
	title,
	image,
	link,
	description,
}: Readonly<CtaBlockFragment>) {
	return (
		<section
			className={clsx(
				'cta-block-section relative bg-cover bg-center h-svh flex items-center justify-center @container',
				image?.[0]?.url &&
					'before:content-[""] before:absolute before:inset-0 before:bg-black/30 before:z-10'
			)}
		>
			{image ? (
				<Image
					src={image[0].url}
					alt={image[0].alt}
					width={image[0].width}
					height={image[0].height}
					className="absolute inset-0 w-full h-full object-cover z-0"
				/>
			) : null}

			<div className="relative container flex flex-col text-center items-center text-white max-w-5xl z-10">
				{/* Title */}
				{title && !isStructuredTextEmpty(title.text) && (
					<h2 className="heading-size-1 mb-4">
						<TextWithHighlight text={title} />
					</h2>
				)}

				{/* Description */}
				{description && !isStructuredTextEmpty(description) && (
					<div className="text-lg @5xl:text-2xl mb-9">
						<StructuredText data={description} />
					</div>
				)}

				{/* CTA */}
				{link ? <CtaDefault cta={link} /> : null}
			</div>
		</section>
	)
}
